import Container from 'react-bootstrap/Container';
import AppButton from '../atoms/AppButton';
import Reveal from '../atoms/Reveal';
import { IconWhatsapp } from '../atoms/Icon';
import StepCard from '../molecules/StepCard';
import { cta, passos } from '../content/site';
import { trackEvent } from '../utils/analytics';

function HowItWorks() {
  return (
    <section className="section" id="como-funciona">
      <Container className="shell">
        <div className="section-head section-head--center">
          <span className="section-kicker">Como funciona</span>
          <h2 className="section-title">Do cadastro ao primeiro pedido em quatro passos</h2>
          <p className="section-lead">
            Sem integração para contratar, sem maquininha para comprar e sem treinamento de
            duas horas. O que muda na sua rotina é o pedido chegar escrito.
          </p>
        </div>

        <div className="step-grid">
          {passos.map((passo, i) => (
            <Reveal key={passo.titulo} stagger={i}>
              <StepCard numero={i + 1} titulo={passo.titulo} texto={passo.texto} />
            </Reveal>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-5">
          <AppButton
            href={cta.principal.href}
            variant="whatsapp"
            onClick={() => trackEvent('click_whatsapp', { posicao: 'como_funciona' })}
          >
            <IconWhatsapp size={17} />
            {cta.principal.label}
          </AppButton>
        </div>
      </Container>
    </section>
  );
}

export default HowItWorks;
